export default "__VITE_ASSET__9VzwkBL2__"